import { Card } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { AlertTriangle, TrendingUp, Users, DollarSign } from "lucide-react"

const tickets = [
  {
    id: 1,
    message: "Корзина не работает, не могу оформить заказ!",
    time: "2 мин назад",
    category: "Оформление заказа",
    critical: true,
  },
  {
    id: 2,
    message: "При клике на купить ничего не происходит",
    time: "5 мин назад",
    category: "Оформление заказа",
    critical: true,
  },
  {
    id: 3,
    message: "Страница каталога грузится очень долго",
    time: "12 мин назад",
    category: "Производительность",
    critical: false,
  },
]

export function SupportTicketDemo() {
  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:gap-6">
      {/* Left: Incoming tickets */}
      <Card className="flex-1 bg-card p-4 lg:p-6">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-foreground font-semibold">Входящие обращения</h3>
          <Badge variant="secondary" className="bg-primary/10 text-primary">
            312 за неделю
          </Badge>
        </div>
        <div className="flex flex-col gap-3">
          {tickets.map((ticket) => (
            <div key={ticket.id} className="bg-muted/50 flex items-start gap-3 rounded-lg p-3">
              <div
                className={`mt-1 h-2 w-2 shrink-0 rounded-full ${ticket.critical ? "bg-destructive" : "bg-primary"}`}
              />
              <div className="flex-1">
                <p className="text-foreground text-sm">{ticket.message}</p>
                <div className="mt-1 flex items-center gap-2">
                  <span className="text-muted-foreground text-xs">{ticket.time}</span>
                  <Badge variant="outline" className="text-xs">
                    {ticket.category}
                  </Badge>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Card>

      {/* Right: Analysis result */}
      <Card className="flex-1 border-primary/20 bg-card p-4 lg:p-6">
        <div className="mb-4 flex items-center gap-2">
          <AlertTriangle className="text-destructive h-5 w-5" />
          <h3 className="text-foreground font-semibold">Выявлена критическая проблема</h3>
        </div>
        <div className="bg-destructive/5 mb-4 rounded-lg p-4">
          <h4 className="text-foreground mb-2 font-medium">Проблема с оформлением заказа</h4>
          <p className="text-muted-foreground mb-3 text-sm">47 обращений от 32 клиентов за последние 3 дня</p>
          <div className="grid grid-cols-3 gap-3">
            <div className="flex items-center gap-2">
              <Users className="text-primary h-4 w-4" />
              <span className="text-foreground text-sm font-medium">32 клиента</span>
            </div>
            <div className="flex items-center gap-2">
              <DollarSign className="text-primary h-4 w-4" />
              <span className="text-foreground text-sm font-medium">$23,000/мес</span>
            </div>
            <div className="flex items-center gap-2">
              <TrendingUp className="text-destructive h-4 w-4" />
              <span className="text-destructive text-sm font-medium">Растёт</span>
            </div>
          </div>
        </div>
        <p className="text-muted-foreground text-sm">
          Система автоматически объединила похожие обращения и рассчитала бизнес-влияние
        </p>
      </Card>
    </div>
  )
}
